// extracted by mini-css-extract-plugin
export default {"dataNotification":"tourists-module__dataNotification__80Kg1","mobileDataNotification":"tourists-module__mobileDataNotification__WOzds"};